import {
  AccordionSummary,
  Chip,
  makeStyles,
  Typography
} from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';
import React from 'react';

type ShareSectionHeaderProps = {
  label: string;
  count?: number;
  newCount?: number;
  icon?: React.ReactElement;
};

const useClasses = makeStyles(theme => ({
  root: {
    backgroundColor: '#82a4c3',
    color: theme.palette.common.white
  },
  labelContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  },
  countChip: {
    backgroundColor: theme.palette.common.white,
    color: '#82a4c3',
    height: 18,
    fontSize: '0.7rem',
    fontWeight: 'bold'
  },
  newChip: {
    backgroundColor: '#4caf50',
    color: theme.palette.common.white,
    height: 18,
    fontSize: '0.7rem'
  }
}));

const ShareSectionHeader = function ShareSectionHeader({
  label,
  count,
  newCount,
  icon
}: ShareSectionHeaderProps): React.ReactElement {
  const classes = useClasses();
  return (
    <AccordionSummary
      expandIcon={<ExpandMore />}
      classes={{ root: classes.root }}
    >
      <div className={classes.labelContainer}>
        {icon && React.cloneElement(icon, { style: { fontSize: '1.1rem' } })}
        <Typography>{label}</Typography>
        {count !== undefined && (
          <Chip label={count} size='small' className={classes.countChip} />
        )}
        {newCount !== undefined && newCount > 0 && (
          <Chip
            label={`${newCount} New!`}
            size='small'
            className={classes.newChip}
          />
        )}
      </div>
    </AccordionSummary>
  );
};

export default ShareSectionHeader;
